import { api } from "./api";

export interface SkillDef {
  id: string;
  org_id: string;
  name: string;
  description: string;
  content: string;
  triggers: string[];
  created_by: string;
  created_at: string;
}

export type SkillCreateData = Omit<SkillDef, "id" | "org_id" | "created_by" | "created_at">;
export type SkillUpdateData = Partial<SkillCreateData>;

export const skillService = {
  list: (orgId: string) => api.get<SkillDef[]>(`/orgs/${orgId}/skills`),
  create: (orgId: string, data: SkillCreateData) =>
    api.post<SkillDef>(`/orgs/${orgId}/skills`, data),
  update: (orgId: string, skillId: string, data: SkillUpdateData) =>
    api.put<SkillDef>(`/orgs/${orgId}/skills/${skillId}`, data),
  delete: (orgId: string, skillId: string) =>
    api.delete(`/orgs/${orgId}/skills/${skillId}`),
};
